/**
 * Capitalizes the first letter of each word in a string
 * Example: "business_permit" -> "Business Permit"
 *          "new_application" -> "New Application"
 * @param {string} value - The string to capitalize
 * @returns {string} - The capitalized string or '-' if empty
 */
export const capitalizeWords = (value) => {
  if (!value || typeof value !== 'string') return '-';

  return value
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (char) => char.toUpperCase());
};
